import { UnstyledButton } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { defaultFiltersParams } from "#app/routes/pages/Search.page";
import { colors } from "#app/theme/v2/colors";
import { radius } from "#app/theme/v2/radius";
import { spacing } from "#app/theme/v2/spacing";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { SimilarPartsModal } from "#modules/quoteRequestLines/views/SimilarPartsModal";
import { Icon } from "#shared/icons/Icon";
import { DEFAULT_DIMENSION_WEIGHT } from "#shared/view/components/FilterButton";
import { FilterQuery } from "shared";

type Props = {
  line: QuoteRequestLineDto;
};

export const SimilarPartCell = ({ line }: Props) => {
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure(false);
  const [filtersParams, setFiltersParams] = useState<FilterQuery>(defaultFiltersParams);
  const [dimensionWeight, setDimensionWeight] = useState(DEFAULT_DIMENSION_WEIGHT);

  return (
    <>
      <UnstyledButton
        onClick={open}
        style={{
          display: "flex",
          alignItems: "center",
          flexShrink: 0,
          gap: spacing[1.5],
          borderRadius: radius.lg,
          padding: `${spacing[2]} ${spacing[3]}`,
        }}
        aria-label={t("qrl.prediction.reliable.label")}
      >
        <Icon name="history" size={16} color={colors.text.primaryDefault} />
      </UnstyledButton>
      <SimilarPartsModal
        quoteRequestLine={line}
        opened={opened}
        onClose={close}
        filtersParams={filtersParams}
        setFiltersParams={setFiltersParams}
        dimensionWeight={dimensionWeight}
        setDimensionWeight={setDimensionWeight}
      />
    </>
  );
};
